import { useState, useEffect } from "react";

// Same breakpoint as Tailwind's `md`, which the desktop UI already uses
// for `hidden md:flex` / `md:left-[160px]`. Keeping them identical means
// the mobile shell takes over exactly where the desktop one gives up.
export const MOBILE_QUERY = "(max-width: 767px)";

const supportsMatchMedia = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

const getInitialMatch = () =>
  supportsMatchMedia() ? window.matchMedia(MOBILE_QUERY).matches : false;

// Adds `vaboo-mobile` to <body> while on a narrow viewport. Every rule in
// public/mobile.css is scoped to that class AND wrapped in a max-width media
// query, so nothing there can ever apply to the desktop layout.
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(getInitialMatch);

  useEffect(() => {
    if (!supportsMatchMedia()) return;

    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);

    setIsMobile(mql.matches);

    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    // Safari < 14
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("vaboo-mobile", isMobile);
  }, [isMobile]);

  return isMobile;
};

export default useIsMobile;
